var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.listPagination !== null) ? _c('nav', {
    attrs: {
      "aria-label": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination justify-content-center"
  }, [(_vm.listPagination.pages < 7) ? [_vm._l((_vm.listPagination.pages), function(item) {
    return [_c('li', {
      staticClass: "page-item",
      class: item === _vm.listPagination.page ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.listPagination.page !== item ? _vm.setPage(item) : null
        }
      }
    }, [_c('a', {
      staticClass: "page-link"
    }, [_vm._v(_vm._s(item))])])]
  })] : [_c('li', {
    staticClass: "page-item",
    class: _vm.listPagination.page === 1 ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.listPagination.page !== 1 ? _vm.setPage(1) : null
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v("1")])]), _vm._v(" "), (_vm.listPagination.page > 3) ? _c('li', {
    staticClass: "page-item disabled"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page > 2) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setPage(_vm.listPagination.page - 1)
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.page - 1))])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page > 1 && _vm.listPagination.page < _vm.listPagination.pages) ? _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.page))])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page < (_vm.listPagination.pages - 1)) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setPage(_vm.listPagination.page + 1)
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page < (_vm.listPagination.pages - 2)) ? _c('li', {
    staticClass: "page-item disabled"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.listPagination.page === _vm.listPagination.pages ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.listPagination.page !== _vm.listPagination.pages ? _vm.setPage(_vm.listPagination.pages) : null
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.pages))])])]], 2)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659299a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginationComponent.vue
// module id = 393
// module chunks = 0